import React from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import ChangeLang from '../../../components/changeLang';
import QRCode from 'react-qr-code';
import backgroundImage from './assets/bk.png';
import { useSelector } from 'react-redux';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
const Index = ({
  showBack = true,
  showImageTop = false,
  children,
  showLogo = true,
  showFooter = true,
  setShowListProduct,
  setShowSpecials,
  setShowGame,
  goHome,
}) => {
  const [showModal, setShowModal] = React.useState(false);

  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState('');

  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false);
    }
  };

  const { goHomeInit } = useSelector((state) => state.initLoad);

  const validScret = () => {
    if (secret === '') {
      alert('Debe ingresar el pin');
    }

    if (secret === '2355') {
      window.location.reload();
    } else {
      alert('Code invalid');
    }
  };

  return (
    <div
      className="backgroundlayout"
      id="backgroundlayout"
      style={{
        flex: 1,
        width: '100%',
        height: '100vh',
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {showImageTop && (
        <img
          src={require('./assets/left.png')}
          style={{
            width: 220,
            height: '100%',
            position: 'absolute',
            left: 0,
            top: 5,
            objectFit: 'cover',
            zIndex: 1000,
          }}
        />
      )}

      <div>
        {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}

        <div className="contentChild">
          <div
            className="nav-menu-bar"
            style={{
              marginTop: -4,
              width: '100%',
              position: 'relative',
            }}
          >
            {showLogo && (
              <div
                style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  {showBack && (
                    <div
                      onClick={() => handleButtonClick()}
                      style={{
                        width: 140,
                        height: 52,
                        display: 'flex',
                        textAlign: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        marginLeft: 35,
                        fontWeight: 'bold',
                        zIndex: 999,
                        position: 'relative',
                        backgroundColor: '#ED3E08',
                        borderRadius: 100,
                      }}
                    >
                      <img
                        src={require('./assets/back.png')}
                        style={{ width: 30, height: 30 }}
                      />

                      <p
                        style={{
                          fontFamily: 'Watchtower',
                          color: '#fff',
                          fontWeight: '500',
                          fontSize: 35,
                          marginLeft: 10,
                          textTransform: 'uppercase',
                          margin: 0,
                        }}
                      >
                        GO BACK
                      </p>
                    </div>
                  )}
                </div>

                <div style={{ width: '35%', alignItems: 'center' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'relative',
                      zIndex: 999,
                      justifyContent: 'end',
                    }}
                  >
                    <div
                      onClick={() =>
                        setShowModal(
                          'https://www.instagram.com/mamajuanacafeplainfield/?hl=es',
                        )
                      }
                      target="_blank"
                    >
                      {' '}
                      <img
                        style={{
                          width: 28,
                          height: 28,
                          marginInline: 10,
                        }}
                        src={require('./assets/instagram.png')}
                        alt="Logo"
                      />
                    </div>

                    <div
                      target="_blank"
                      onClick={() =>
                        setShowModal(
                          'https://www.facebook.com/p/Mamajuana-Cafe-Plainfield-100088672585933/',
                        )
                      }
                    >
                      <img
                        style={{
                          width: 28,
                          height: 28,
                          marginInline: 10,
                        }}
                        src={require('./assets/facebook.png')}
                        alt="Logo"
                      />
                    </div>

                    <div
                      target="_blank"
                      onClick={() =>
                        setShowModal('https://mamajuanacafeplainfield.com/')
                      }
                    >
                      <img
                        style={{
                          width: 30,
                          height: 30,
                          marginInline: 10,
                        }}
                        src={require('./assets/web.png')}
                        alt="Logo"
                      />
                    </div>

                    <div></div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {children}

          {showFooter && (
            <div
              style={{
                width: '100%',
                position: 'absolute',
                bottom: 0,
                left: showImageTop ? '5%' : 0,
                alignSelf: 'center',
              }}
            >
              <div
                style={{
                  paddingHorizontal: 40,
                  paddingVertical: 15,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 5,
                  gap: 20,
                  width: '100%',
                }}
              >
                <div
                  onClick={() => {
                    handleButtonClick();
                    store.dispatch(setGoHome(!goHomeInit));
                    console.log({ goHome });
                    if (goHome) {
                      goHome();
                    }
                  }}
                  style={{
                    width: 170,
                    height: 60,
                    borderRadius: 100,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    boxSizing: 'border-box',
                    padding: '0 30px',
                    alignItems: 'center',
                    flexDirection: 'row',
                    backgroundColor: '#ED3E08',
                  }}
                >
                  <img
                    src={require('./assets/home.png')}
                    style={{ width: 35, height: 35 }}
                  />

                  <p
                    style={{
                      fontFamily: 'Watchtower',
                      color: '#fff',
                      fontWeight: '800',
                      fontSize: 35,
                      textTransform: 'uppercase',
                      margin: 0,
                    }}
                  >
                    Home
                  </p>
                </div>

                <div
                  onClick={() => {
                    if (setShowSpecials) {
                      setShowSpecials(true);
                    }
                  }}
                  style={{
                    width: 180,
                    height: 60,
                    borderRadius: 100,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    boxSizing: 'border-box',
                    padding: '0 20px',
                    paddingHorizontal: 20,
                    alignItems: 'center',
                    flexDirection: 'row',
                    backgroundColor: '#ED3E08',
                  }}
                >
                  <img
                    src={require('./assets/events.png')}
                    style={{ width: 35, height: 35 }}
                  />

                  <p
                    style={{
                      fontFamily: 'Watchtower',
                      color: '#fff',
                      fontWeight: '800',
                      fontSize: 35,
                      textTransform: 'uppercase',
                      margin: 0,
                    }}
                  >
                    Events
                  </p>
                </div>
                {/* <div
                    onClick={() => {
                      if (setShowGame) {
                        setShowGame(true)
                      }
                }}
                style={{
                   width: 170,
                  height: 60,
                  borderRadius: 100,
                    marginHorizontal: 10,
                  display: 'flex',
                  justifyContent: 'space-between',
                 boxSizing: 'border-box',
                  padding: '0 20px',
                  paddingHorizontal: 20,
                  alignItems: 'center',
                  flexDirection: 'row',
                  backgroundColor: "#ED3E08"
                  }}>
                
                  <img src={require('./assets/game.png')}  style={{ width: 40,
                        height: 40,
                      }} />
                    
                <p
                    style={{
                     fontFamily:"Watchtower",
                      color: '#fff',
                      fontWeight: '800',
                      fontSize: 35,
                      textTransform: 'uppercase',
                     margin: 0,
                      
                    }}>
                    Games
                  </p>
                
              </div> */}
              </div>
              <div
                style={{
                  zIndex: 100,
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  paddingHorizontal: 20,
                  paddingVertical: 5,
                  alignItems: 'center',
                  marginTop: 15,
                  marginBottom: 10,
                }}
              >
                <div
                  onClick={() => setshowBoost(true)}
                  style={{ flexDirection: 'row', alignItems: 'center' }}
                >
                  <p
                    style={{
                      color: '#B8A8A8',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}
                  >
                    Powered by boostyourmenu.com V1.1
                  </p>
                </div>
              </div>
            </div>
          )}

          {showModalPincode && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#00000063',
                zIndex: 9999,
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  background: '#fff',
                  width: 500,
                  height: 300,
                  borderRadius: 30,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <img
                  onClick={() => setShowModalPincode(false)}
                  style={{
                    position: 'absolute',
                    top: -10,

                    width: 40,
                    height: 40,
                    marginInline: 10,
                    objectFit: 'contain',
                    position: 'absolute',
                    right: -10,
                    zIndex: 9999,
                  }}
                  src={require('./assets/close.png')}
                  alt="Logo"
                />
                <h4
                  style={{
                    color: '#F40000',
                    fontSize: 40,
                    fontWeight: 'bold',
                    margin: 20,
                  }}
                >
                  PIN
                </h4>
                <input
                  type="number"
                  style={{ width: 300, height: 40 }}
                  onChange={(e) => {
                    setScret(e.target.value);
                  }}
                />
                <br />
                <br />

                <div style={{ display: 'flex', gap: 20 }}>
                  <div
                    onClick={() => setShowModalPincode(false)}
                    style={{
                      background: '#FF1616',
                      width: 150,
                      height: 50,
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      borderRadius: 7,
                    }}
                  >
                    <p
                      style={{
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                      }}
                    >
                      atras
                    </p>
                  </div>
                  <div
                    onClick={() => validScret()}
                    style={{
                      background: '#FF1616',
                      width: 150,
                      height: 50,
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      borderRadius: 7,
                    }}
                  >
                    <p
                      style={{
                        color: 'white',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                      }}
                    >
                      Enviar
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showBoost && (
            <div
              onClick={() => setshowBoost(false)}
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#00000063',
                zIndex: 9999,
                flexDirection: 'column',
              }}
            >
              <img
                style={{
                  width: 500,
                  height: 500,
                  marginInline: 10,
                  objectFit: 'contain',
                  zIndex: 9999,
                }}
                src={require('./assets/boost.png')}
                alt="Logo"
              />
            </div>
          )}

          <img
            onClick={() => setShowModalPincode(true)}
            style={{
              width: 40,
              height: 40,
              marginInline: 10,
              objectFit: 'contain',
              position: 'absolute',
              bottom: 10,
              right: 0,
              zIndex: 100,
            }}
            src={require('./assets/pincode.png')}
            alt="Logo"
          />

          {showModal && (
            <div
              onClick={() => setShowModal(false)}
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#00000063',
                zIndex: 9999,
              }}
            >
              <QRCode
                size={256}
                style={{ height: 400, width: 400 }}
                value={showModal}
                divBox={`0 0 256 256`}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Index;
